var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "29"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 28.387v-28h28v28z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "m14 19.055 8.587-6.685 1.913-1.48L14 2.722 3.5 10.889l1.902 1.481zm-.012 2.964L5.39 15.334l-1.89 1.47L14 24.97l10.5-8.166-1.902-1.482z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }